<template>
  <div class="card" :class="{ 'card--dense': dense, 'card--minify': minify, 'card--outline': outline }">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'Card',
    props: [
        'dense',
        'minify',
        'outline'
    ],
};
</script>
